import { Center, CenterProps } from "@chakra-ui/react";
import React from "react";

import styles from "./LoadingIndicatorVisual.module.css";

const LoadingIndicatorVisual: React.FC<CenterProps> = (props) => {
  return (
    <Center overflow="hidden" mx="auto" className={styles.LoadingIndicatorVisualWrapper} {...props}>
      <img
        className={styles.LoadingIndicatorVisualImage}
        src="./assets/images/loading_gear_blue.svg"
        alt="Loading"
      />
      <div className={styles.LoadingIndicatorVisualHighlight} />
      <div className={styles.LoadingIndicatorVisualLight} />
    </Center>
  );
};

export default LoadingIndicatorVisual;
